// https://stackoverflow.com/a/62804866/5805180
export const isNotificationApiSupported = () => {
    return 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;
};
